import { render, staticRenderFns } from "./my-select.vue?vue&type=template&id=33d723d1&scoped=true&"
import script from "./my-select.vue?vue&type=script&lang=js&"
export * from "./my-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d723d1",
  null
  
)

export default component.exports